

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CourseDocumentInfoEdit as ICourseDocumentInfoEdit } from "@/api-v2/course-document-info/models";
import { Term as ITerm, TermList as ITermList } from "@/api/models";
import professionalActivity from "@/getinfo-api/professionalActivity";
import professionalProrgamm from "@/getinfo-api/professionalProrgamm";
import specialty from "@/getinfo-api/specialty";
import termDocTypes from "@/getinfo-api/documentType";

@Component({
  components: {
    CSingleSelect,
    EditorWithFile,
    CBlock,
    CField
  }
})
export default class CourseInfoForm extends Vue {
  @Prop() documentInfo!: ICourseDocumentInfoEdit;
  termListProgram: Array<ITerm> = [];
  termListActivity: Array<ITerm> = [];
  termListSpeciality: Array<ITerm> = [];
  termDocTypes: Array<ITerm> = [];

  documentForm: ICourseDocumentInfoEdit = {
    programId: undefined,
    qualification: undefined,
    specialtyId: undefined,
    activityId: undefined,
    documentTypeId: undefined,
    validityOfDocument: 0
  };

  @Watch("documentForm", { immediate: true, deep: true })
  checkDocumentForm() {
    if (this.documentForm) {
      this.$emit("input", this.documentForm);
    }
  }

  formatterValidityOfDocument() {
    if (
      this.documentForm.validityOfDocument &&
      this.documentForm.validityOfDocument < 0
    ) {
      this.documentForm.validityOfDocument = 0;
    }
  }

  getTaxonomy() {
    let params: any = {
      limit: 500
    };
    termDocTypes(params).then((res: { data: ITermList }) => {
      this.termDocTypes = [...this.termDocTypes, ...res.data.items];
    });

    professionalActivity(params).then((res: { data: ITermList }) => {
      this.termListActivity = [...this.termListActivity, ...res.data.items];
    });

    professionalProrgamm(params).then((res: { data: ITermList }) => {
      this.termListProgram = [...this.termListProgram, ...res.data.items];
    });

    specialty(params).then((res: { data: ITermList }) => {
      this.termListSpeciality = [...this.termListSpeciality, ...res.data.items];
    });
  }

  created() {
    this.documentForm ? (this.documentForm = this.documentInfo) : null;
    this.getTaxonomy();
  }
}
